import { render } from "./Comment.vue?vue&type=template&id=45d1b0c5&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=45d1b0c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45d1b0c5"

export default script